require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-shopify-pay-what-is-it-and-why-is-it-so-important.json") })
        }
      }, "path---blog-shopify-pay-what-is-it-and-why-is-it-so-important");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-shopify-pay-what-is-it-and-why-is-it-so-important!./.cache/json/blog-shopify-pay-what-is-it-and-why-is-it-so-important.json
// module id = 485
// module chunks = 231608221292675